import { SwiperCarousel } from '@alf/uikit';
import { SliderHeader } from './components/SliderHeader';
import { SliderItem } from './components/SliderItem';

import styles from '../index.module.css';

export const SliderContainer = ({
  bonuses,
  handleBonusClick,
  activeBonusId,
  userCurrency
}) => {
  return (
    <SwiperCarousel
      headerComponent={
        <SliderHeader bonuses={bonuses} activeBonusId={activeBonusId} />
      }
      horizontal={true}
      resizeOnContentsReady={true}
      overflow="true"
      circularSlidesCount={1000}
      slider={{ slider: styles.slider }}
      navigation={{
        arrows: true
      }}
      arrow={{
        isHideAtEdge: true
      }}
      autoPlay={false}
      animationDuration={200}
      inputType={['touch']}
      slidesPerView="auto"
      spaceBetween={8}
    >
      {bonuses.map((bonus) => (
        <SliderItem
          bonus={bonus}
          key={bonus.bonusId || bonus.freespinId || bonus.bonusName}
          onClick={handleBonusClick}
          activeBonusId={activeBonusId}
          userCurrency={userCurrency}
        />
      ))}
    </SwiperCarousel>
  );
};
